import { useNavigate } from "react-router-dom";
import { useResources } from "../../hooks/useResources";
import { usePermissions } from "../../hooks/usePermissions";
import ContentHeader from "../contentHeader/ContentHeader";

interface TableHeaderProps {
  title: string;
  uploadFilesLabel: string;
  onCSVDownload?: () => void;
  uploadFilesPath?: string;
  isCSVDisabled?: boolean;
}

const TableHeader = ({ title, uploadFilesLabel, onCSVDownload, uploadFilesPath = "/upload-jobs", isCSVDisabled = false }: TableHeaderProps) => {
  const { getResourceValue } = useResources();
  const navigate = useNavigate();
  const { canUploadJobs } = usePermissions();

  const handleUploadFilesClick = () => {
    navigate(uploadFilesPath);
  };

  return (
    <ContentHeader
      title={title}
      headingLevel={2}
      className="content-header--table-header"
      actions={
        <>
          <button 
            className="btn btn-green" 
            onClick={onCSVDownload}
            disabled={isCSVDisabled}
            style={{ opacity: isCSVDisabled ? 0.5 : 1, cursor: isCSVDisabled ? 'not-allowed' : 'pointer' }}
          >
            <i className="f-icon download-icon"></i>
            {getResourceValue("csv", "CSV")}
          </button>
          {canUploadJobs && (
            <button className="btn btn-green" onClick={handleUploadFilesClick}>
              <i className="f-icon upload-icon"></i>
              {uploadFilesLabel}
            </button>
          )}
        </>
      }
    />
  );
};

export default TableHeader;
